var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDecreaseFont = function SvgDecreaseFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#499D71",
    d: "M13.186 6.143H9.758a.65.65 0 0 1-.644-.643c0-.352.292-.643.643-.643h3.4290000000000003c.351 0 .643.291.643.643a.65.65 0 0 1-.643.643M4.063 0h2.088l4.063 11H7.966l-.932-2.787H3.051L2.12 11H0zm2.393 6.498L5.043 2.226l-1.43 4.272z"
  })));
};
export default SvgDecreaseFont;